import React, { useState, useLayoutEffect } from "react";
import { Tabs, Tab } from "@material-ui/core";
import InaccessibleResources from "../../helpers/InaccessibleResources";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";

const freeLicenseName = process.env.REACT_APP_FREE_ORGANIZATION_LICENSE;
const freeLicenses = [freeLicenseName];
const EMBED_PAGE_BODY_CLASS = "event-insight-embed-active";

const EventInsight = ({ licenseName, message }) => {
  const [activeTab, setActiveTab] = useState(() => {
    const tab = new URLSearchParams(window.location.search).get("tab");
    return tab === "immediate-actions" ? "immediate-actions" : "event-insight";
  });

  // Lock outer layout scroll before paint; cleanup restores normal scrolling on leave.
  useLayoutEffect(() => {
    document.body.classList.add(EMBED_PAGE_BODY_CLASS);
    return () => {
      document.body.classList.remove(EMBED_PAGE_BODY_CLASS);
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "event-insight":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return <GetKibanaDashboard dashboardKey={"Event_Insight_New"} />;
        }
        case "threat-detection":
          if (freeLicenses.includes(licenseName)) {
            return <InaccessibleResources message={message} />;
          } else {
            return <GetKibanaDashboard dashboardKey={"Event Detection POC"} />;
          }        
      case "mitre-attack":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return <GetKibanaDashboard dashboardKey={"MItre_event Insight"} />;
        }
      case "immediate-actions":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return (
            <GetKibanaDashboard
              dashboardKey={"Immediate Action Required — Security Response"}
            />
          );
        }
      default:
        return null;
    }
  };

  return (
    <div className="event-insight-embed-page">
      {/* Tabs stay in place; iframe fills remaining viewport so only it scrolls */}
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="IMMEDIATE ATTENTION" value="immediate-actions" />
        <Tab label="Cloud Event" value="event-insight" />
        <Tab label="Threat Detection" value="threat-detection" />
        <Tab label="Mitre Attack" value="mitre-attack" />
      </Tabs>
      <div className="event-insight-embed-body">{renderTabContent()}</div>
    </div>
  );
};

export default EventInsight;
